<template>
    <div class="max-h-500px overflow-y-auto">
        <div class="flex items-center justify-between">
            <div>

            </div>
            <div class="text-16px font-900 color-#01031B mb-5px">
                {{ t('report.title') }}
            </div>
            <div class="cursor-pointer" @click="handleClose">
                <img src="@/assets/images/message/close.webp" alt="" class="w-30px h-30px"></img>
            </div>
        </div>
        <div class="text-12px color-#01031B">
            {{ t('report.chooseReact') }}
        </div>
        <div>
            <div v-for="(item, index) in reportType" :key="item.id" class="report-item"
                :class="{ 'active': active === index }" @click="hanldeClick(index)">
                <div class="text-12px report-item-text">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div>
            <div class="color-#01031B mt-10px text-12px mb-12px">
                {{ t('report.other') }}
            </div>
            <div class="">
                <textarea v-model="message" rows="3" name="" :placeholder="t('report.placeholder')" class="input"
                    @focus="handleInputFocus" @blur="handleInputBlur"></textarea>
            </div>
        </div>
        <div class="report-btn" :class="{ 'activeBtn': !!message }" @click="handleSubmit">
            {{ t('report.submit') }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { MessageAPI } from '@/services/message'
import { ref } from 'vue'
import { showSuccessToast, showErrorToast, showLoadingToast } from '@/utils/toast'
import { useI18n } from 'vue-i18n'
import { useIOSKeyboard } from '@/composables/useIOSKeyboard'

const { t } = useI18n()
const props = defineProps<{
    close: () => void
    reportType: any[]
    info: any,
    recordId: any
}>()
const message = ref('')
const active = ref(0)

// iOS 键盘处理
const { handleInputFocus, handleInputBlur } = useIOSKeyboard()

const hanldeClick = (index: number) => {
    active.value = index
}

const handleClose = () => {
    props.close()
}

const handleSubmit = async () => {
    if (!message.value) {
        showErrorToast(t('report.pleaseEnterContent'))
        return
    }
    showLoadingToast()
    try {
        await MessageAPI.submitReport({
            roleId: props.info.id,
            type: props.reportType[active.value].id,
            content: message.value,
            recordId: Number(props.recordId),
        })
        showSuccessToast(t('message.reportSuccess'))
        // 重置表单，下次打开时干净
        message.value = ''
        active.value = 0
        props.close()
    } catch (error) {
        showErrorToast(t('message.reportFailed'))
    }
}

</script>

<style scoped lang="scss">
.report-item {
    margin-top: 10px;
    background: rgba(1, 3, 27, 0.05);
    border-radius: 10px;
    padding: 12px 20px;
    border: 1px solid transparent;


    .report-item-text {
        color: rgba(1, 3, 27, 0.5);
    }

    &.active {
        border: 1px solid #01031B;
        background: #FFFFFF;
        color: #01031B;
    }

    // opacity: 0.05;
}

.input {
    padding: 10px;
    width: 100%;
    // height: 110px;
    border-radius: 10px;
    background-color: rgba(1, 3, 27, 0.05);
    font-weight: 500;
    font-size: 12px;
    color: #01031B;
    height: 110px;
}

.report-btn {
    font-weight: 900;
    font-size: 16px;
    color: #FFFFFF;
    background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
    opacity: 0.5;
    border-radius: 23px;
    padding: 10px 20px;
    text-align: center;
    margin-top: 10px;
}

.activeBtn {
    opacity: 1 !important;
}
</style>